import lang from "@/views/modules/Opportunitys/language/en";

let metaList = [
    {
        label: lang.LBL_OPPORTUNITY_TITLE,
        link: true,
        columnName: 'opportunity_title',
        width:'250',
    },
   /*  {
        label: lang.LBL_OPPORTUNITY_YEAR,
        link: false,
        columnName: 'opportunity_year',
    },
    {
        label: lang.LBL_OPPORTUNITY_TYPE,
        link: false,
        columnName: 'opportunity_type',
    }, */
    {
        label: lang.LBL_OPPORTUNITY_FUNDER,
        link: false,
        columnName: 'opportunity_funder',
    },
    {
        label: lang.LBL_OPPORTUNITY_DEADLINE,
        link: false,
        columnName: 'deadline',
    },
   /*  {
        label: lang.LBL_ED_SUPPORT,
        link: false,
        columnName: 'is_ed_support',
    },
    {
        label: lang.LBL_STAGE,
        link: false,
        columnName: 'status',
    }, */
    /* {
        label: lang.LBL_FUNDER,
        link: false,
        columnName: 'opportunity_funder',
    },
    {
        label: lang.LBL_SCHEME_TYPE,
        link: false,
        columnName: 'opportunity_type',
    },
    {
        label: lang.LBL_COUNTRY,
        link: false,
        columnName: 'country_name',
    },*/
    {
        label: lang.LBL_OPPORTUNITY_BY,
        link: false,
        columnName: 'created_by',
    },
   /* {
        label: lang.LBL_APPLICATION_BY,
        link: false,
        columnName: 'created_by',
    },
    {
        label: lang.LBL_STAGE,
        link: false,
        columnName: 'status',
    },
    {
        label: lang.LBL_APPLICATION_DATE,
        link: false,
        columnName: 'app_date',
    }, */
];
const link_list = {
    routePath: 'opportunitys',
    title: 'Recent Active Opportunitys',
    search: '',
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: 10,
}
export default { metaList, link_list }